// Port of api/fuel/app/classes/controller/api/monty/families/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT family_id, family_name FROM family WHERE LOWER(family_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND family_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].family_id] = { id: rows[i].family_id, name: rows[i].family_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
